import React from 'react'
import styled from 'styled-components'

import { Icon } from 'components/atoms'

export const Bookmark = styled.button`
  display: none;

  > span:nth-child(1) {
    color: ${ (props) => props.theme.colors['panel-inner-border'] };
  }

  .label {
    color: ${ (props) => props.theme.colors['standard-schwarz'] };
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.39;
    letter-spacing: normal;
    text-align: right;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    display: inline-block;
    white-space: nowrap;
    border: 0;
    background: transparent;
    font-weight: 200;
    padding: 0;

    &:focus,
    &:hover {
      outline: 0;
      color: green;

      span {
        color: ${ (props) => props.theme.colors['aok-gruen'] };
      }
    }
  }
`

export const BookmarkIcon = styled((props) => <Icon { ...props } />)`
  color: ${ (props) => props.theme.colors['panel-inner-border'] };
  font-size: 26px;
  padding: 0 10px;
`
